import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Layout, PageTitle } from "lola-framework-ui-test";
import { BodyCopy } from "./BodyCopy";
import { AuraLayout } from "./AuraLayout";
import { ErrorAlertIcon } from "../assets/icons";
import { FlowHeroMark } from "./FlowHeroMark";
import { ScrollFadeIndicator } from "./ScrollFadeIndicator";
import { useStore } from "../store/globalState";
import { useOfflineStore } from "../store/useOfflineStore";
import "./OfflineOverlay.css";

/**
 * Blocks the UI while the device has no usable network. Routes stay mounted
 * underneath. Closes only when the browser fires `online`.
 *
 * Uses the same AuraLayout + errorView shell as session-expired so desktop
 * keeps the phone-frame card (not a full-bleed white sheet).
 */
export const OfflineOverlay = () => {
  const { t } = useTranslation();
  const visible = useOfflineStore((s) => s.visible);
  const { theme } = useStore();
  const colorConfig = theme.errorView;
  const { title, bodyCopy, iconColors, backgroundIcon } = colorConfig;

  useEffect(() => {
    const onOnline = () => {
      useOfflineStore.getState().clear();
    };
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, []);

  if (!visible) return null;

  return (
    <div className="offline-overlay" role="alert" aria-live="assertive">
      <AuraLayout
        colorConfig={colorConfig}
        className="flow-landing-page offline-overlay__layout"
      >
        <Layout.Content className="landing-section flow-hero-section">
          <ScrollFadeIndicator color={bodyCopy} />

          <section className="flow-hero">
            <FlowHeroMark backgroundIcon={backgroundIcon}>
              <ErrorAlertIcon size={60} colors={iconColors} />
            </FlowHeroMark>
            <section className="landing-container">
              <PageTitle
                highlight={t("offline.title")}
                highlightColor={title}
                secudnary=""
                secudnaryColor={title}
              />
              <BodyCopy textColor={bodyCopy}>
                {t("offline.message")}
              </BodyCopy>
            </section>
          </section>
        </Layout.Content>
      </AuraLayout>
    </div>
  );
};
